import TacticalPage from "./tactical.page"

export default TacticalPage;
